import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const css = `
  .redesign-root{
    --blue: #0072F5;
    --blue-dark: #0052B3;
    --ink: #0B0D10;
    --paper: #F6F4EF;
    --paper-dim: #ECE8DF;
    --line: rgba(11,13,16,0.12);
    background:var(--paper);
    color:var(--ink);
    font-family:'Inter',sans-serif;
    -webkit-font-smoothing:antialiased;
  }
  .redesign-root *{box-sizing:border-box;}
  .redesign-root html{scroll-behavior:smooth;}
  .redesign-root .serif{font-family:'Newsreader', serif; font-weight:400;}
  .redesign-root .wrap{max-width:1240px; margin:0 auto; padding:0 32px;}
  .redesign-root a{color:inherit; text-decoration:none;}

  .redesign-root header{
    position:fixed; top:0; left:0; right:0; z-index:90;
    background:rgba(246,244,239,0.82); backdrop-filter:blur(10px);
    border-bottom:1px solid var(--line);
  }
  .redesign-root nav{
    display:flex; align-items:center; justify-content:space-between;
    padding:20px 32px; max-width:1240px; margin:0 auto;
  }
  .redesign-root .logo{font-weight:800; font-size:18px; letter-spacing:-0.02em;}
  .redesign-root .logo span{color:var(--blue);}
  .redesign-root .nav-links{display:flex; gap:36px; font-size:14px; font-weight:500; order:2;}
  .redesign-root .nav-links a{opacity:.7; transition:opacity .2s;}
  .redesign-root .nav-links a:hover{opacity:1;}
  .redesign-root .nav-actions{display:flex; align-items:center; gap:22px; order:3;}
  .redesign-root .nav-login{font-size:14px; font-weight:600; opacity:.75; transition:opacity .2s;}
  .redesign-root .nav-login:hover{opacity:1;}
  .redesign-root .nav-cta{
    font-size:14px; font-weight:600; padding:10px 20px;
    border:1px solid var(--ink); border-radius:2px;
    transition:background .2s, color .2s;
  }
  .redesign-root .nav-cta:hover{background:var(--ink); color:var(--paper);}
  .redesign-root .nav-toggle{display:none; background:none; border:none; cursor:pointer; padding:8px; margin-left:8px;}
  .redesign-root .nav-toggle span{display:block; width:20px; height:2px; background:var(--ink); margin:4px 0;}

  .redesign-root section[id]{ scroll-margin-top: 96px; }

  .redesign-root .hero{
    padding:172px 0 90px;
    border-bottom:1px solid var(--line);
  }
  .redesign-root .hero-grid{
    display:grid; grid-template-columns:1.4fr 1fr; gap:64px; align-items:end;
  }
  .redesign-root .eyebrow{
    font-size:13px; font-weight:600; letter-spacing:.12em; text-transform:uppercase;
    color:var(--blue-dark); margin-bottom:28px; display:flex; align-items:center; gap:10px;
  }
  .redesign-root .eyebrow::before{content:''; width:7px; height:7px; background:var(--blue); border-radius:50%; display:inline-block;}
  .redesign-root h1{
    font-size:clamp(48px, 7vw, 92px); line-height:0.98; letter-spacing:-0.02em; font-weight:800; margin:0;
  }
  .redesign-root h1 em{font-style:normal; color:var(--blue);}
  .redesign-root .hero-side{padding-bottom:8px;}
  .redesign-root .hero-side p{
    font-size:19px; line-height:1.5; color:#3a3d42; margin-bottom:28px; margin-top:0;
  }
  .redesign-root .hero-actions{display:flex; gap:14px; align-items:center; margin-bottom:32px;}
  .redesign-root .hero-status{border:1px solid var(--line); border-radius:8px; padding:6px 24px; background:#fff;}
  .redesign-root .hero-status .row{display:flex; align-items:center; gap:12px; padding:14px 0; border-top:1px solid var(--line);}
  .redesign-root .hero-status .row:first-child{border-top:none;}
  .redesign-root .hero-status .dot{width:8px; height:8px; border-radius:50%; flex-shrink:0;}
  .redesign-root .hero-status .dot.done{background:var(--blue);}
  .redesign-root .hero-status .dot.active{background:var(--blue); box-shadow:0 0 0 4px rgba(0,114,245,0.16);}
  .redesign-root .hero-status .dot.pending{background:var(--line);}
  .redesign-root .hero-status .label{font-size:14px; font-weight:600;}
  .redesign-root .hero-status .state{margin-left:auto; font-size:12px; color:#6b6e73;}
  .redesign-root .hero-status-caption{font-size:12.5px; color:#6b6e73; margin-top:12px;}
  .redesign-root .btn-primary{
    background:var(--ink); color:var(--paper); padding:15px 26px; font-weight:600; font-size:15px;
    border-radius:2px; transition:background .2s; display:inline-block;
  }
  .redesign-root .btn-primary:hover{background:var(--blue-dark);}
  .redesign-root .btn-text{font-weight:600; font-size:15px; border-bottom:1px solid var(--ink); padding-bottom:2px;}

  .redesign-root .stats-strip{
    border-bottom:1px solid var(--line);
    padding:8px 0;
    background:var(--paper-dim);
  }
  .redesign-root .stats-track{display:grid; grid-template-columns:repeat(4,1fr);}
  .redesign-root .stats-track span{
    font-family:'Newsreader', serif; font-size:20px; padding:14px 20px; color:#55585e;
    border-right:1px solid var(--line); text-align:center;
  }
  .redesign-root .stats-track span:last-child{border-right:none;}
  .redesign-root .stats-track span b{color:var(--ink); font-weight:500;}

  .redesign-root .section{padding:120px 0; border-bottom:1px solid var(--line);}
  .redesign-root .section-head{
    display:grid; grid-template-columns:0.9fr 1.5fr; gap:48px; margin-bottom:72px;
  }
  .redesign-root .section-num{
    font-family:'Newsreader', serif; font-size:15px; color:#6b6e73;
  }
  .redesign-root .section-title{
    font-size:clamp(30px,4vw,46px); font-weight:800; letter-spacing:-0.01em; line-height:1.05;
    margin-bottom:18px;
  }
  .redesign-root .section-desc{font-size:17px; color:#4a4d52; line-height:1.6; align-self:end; margin:0;}

  .redesign-root .services-grid{display:grid; grid-template-columns:repeat(2,1fr); border-top:1px solid var(--line); border-left:1px solid var(--line);}
  .redesign-root .service-cell{
    padding:44px; border-right:1px solid var(--line); border-bottom:1px solid var(--line);
  }
  .redesign-root .service-cell .tag{font-size:12px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:var(--blue-dark); margin-bottom:14px;}
  .redesign-root .service-cell h3{font-size:23px; font-weight:700; letter-spacing:-0.01em; margin-bottom:14px; margin-top:0;}
  .redesign-root .service-cell p{font-size:15.5px; color:#52555a; line-height:1.6; margin-bottom:20px; margin-top:0;}
  .redesign-root .service-cell ul{list-style:none; font-size:13.5px; color:#6a6d72; margin:0; padding:0;}
  .redesign-root .service-cell ul li{padding:6px 0; border-top:1px solid var(--line);}
  .redesign-root .service-cell ul li:first-child{border-top:none;}

  .redesign-root .case-list{display:flex; flex-direction:column; margin-top:80px;}
  .redesign-root .case-card{
    display:grid; grid-template-columns:200px 1fr; gap:40px;
    padding:44px 0; border-top:1px solid var(--line);
  }
  .redesign-root .case-card:last-child{border-bottom:1px solid var(--line);}
  .redesign-root .case-meta{display:flex; flex-direction:column; gap:6px;}
  .redesign-root .case-meta .kicker{font-size:12px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:var(--blue-dark);}
  .redesign-root .case-meta .status{font-size:12.5px; color:#6b6e73;}
  .redesign-root .case-body h3{font-size:26px; font-weight:700; letter-spacing:-0.01em; margin-bottom:6px; margin-top:0;}
  .redesign-root .case-body .sub{font-size:15px; color:#6a6d72; margin-bottom:20px;}
  .redesign-root .case-row{display:grid; grid-template-columns:1fr 1fr 1fr; gap:28px; margin-bottom:20px;}
  .redesign-root .case-row .label{font-size:11px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin-bottom:6px;}
  .redesign-root .case-row p{font-size:14.5px; color:#3a3d42; line-height:1.55; margin:0;}
  .redesign-root .case-stack{display:flex; flex-wrap:wrap; gap:8px;}
  .redesign-root .case-stack span{font-size:12px; background:var(--paper-dim); padding:5px 12px; border-radius:20px; color:#52555a;}

  .redesign-root .case-visual{margin-top:28px;}
  .redesign-root .case-visual-row{display:flex; flex-wrap:wrap; gap:24px;}
  .redesign-root .case-visual-row .browser-frame-sm{max-width:420px; flex:1 1 380px;}
  .redesign-root .browser-frame-sm{
    border:1px solid var(--line); border-radius:8px; overflow:hidden; max-width:480px;
    box-shadow:0 16px 40px -16px rgba(11,13,16,0.18); background:#fff;
  }
  .redesign-root .browser-frame-sm .bar{display:flex; align-items:center; gap:6px; padding:10px 14px; background:var(--paper-dim); border-bottom:1px solid var(--line);}
  .redesign-root .browser-frame-sm .bar i{width:8px; height:8px; border-radius:50%; background:#d6d2c6; display:block;}
  .redesign-root .browser-frame-sm .bar-label{margin-left:auto; font-size:11px; color:#6b6e73;}
  .redesign-root .browser-frame-sm img{display:block; width:100%; height:auto;}
  .redesign-root .phone-frame-sm{
    width:220px; border:8px solid var(--ink); border-radius:32px; overflow:hidden;
    box-shadow:0 16px 40px -16px rgba(11,13,16,0.22);
  }
  .redesign-root .phone-frame-sm img{display:block; width:100%; height:auto;}

  .redesign-root .process-list{display:flex; flex-direction:column;}
  .redesign-root .process-item{
    display:grid; grid-template-columns:120px 1fr; gap:32px; padding:44px 0;
    border-top:1px solid var(--line);
  }
  .redesign-root .process-item:last-child{border-bottom:1px solid var(--line);}
  .redesign-root .process-step{font-family:'Newsreader', serif; font-size:54px; color:var(--blue); line-height:1;}
  .redesign-root .process-item h3{font-size:24px; font-weight:700; margin-bottom:10px; margin-top:0; letter-spacing:-0.01em;}
  .redesign-root .process-item p{font-size:16px; color:#52555a; max-width:560px; line-height:1.6; margin:0;}

  .redesign-root .network-label{font-size:12px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin:60px 0 24px;}
  .redesign-root .network-grid{display:grid; grid-template-columns:repeat(3,1fr); gap:1px; background:var(--line); border:1px solid var(--line);}
  .redesign-root .network-cell{background:var(--paper); padding:32px;}
  .redesign-root .network-cell h4{font-size:17px; font-weight:700; margin-bottom:10px; margin-top:0; letter-spacing:-0.01em;}
  .redesign-root .network-cell p{font-size:14px; color:#52555a; line-height:1.55; margin:0;}
  .redesign-root .assemble-block{
    background:var(--paper-dim); border-radius:6px; padding:40px; max-width:760px; margin-top:48px;
  }
  .redesign-root .assemble-block p{font-size:16px; color:#3a3d42; line-height:1.6; margin:0;}

  .redesign-root .quote-section{padding:140px 0; background:var(--ink); color:var(--paper); border-bottom:none;}
  .redesign-root .quote-section .wrap{max-width:920px;}
  .redesign-root .quote-section p{
    font-family:'Newsreader', serif; font-size:clamp(28px,4vw,42px); line-height:1.3; letter-spacing:-0.01em; margin:0;
  }
  .redesign-root .quote-section .by{margin-top:32px; font-family:'Inter'; font-size:14px; color:#9CC9FF; font-weight:600;}

  .redesign-root .pricing-strip{
    display:grid; grid-template-columns:repeat(3,1fr); border-top:1px solid var(--line);
  }
  .redesign-root .pricing-cell{
    padding:48px 40px; border-right:1px solid var(--line);
  }
  .redesign-root .pricing-cell:last-child{border-right:none;}
  .redesign-root .pricing-cell .tier{font-size:13px; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin-bottom:16px;}
  .redesign-root .pricing-cell .price{font-family:'Newsreader', serif; font-size:40px; margin-bottom:14px;}
  .redesign-root .pricing-cell .price span{font-size:16px; color:#6b6e73;}
  .redesign-root .pricing-cell ul{list-style:none; margin-top:20px; font-size:14px; color:#52555a; line-height:2; padding:0;}

  .redesign-root .cta-final{padding:140px 0; text-align:center;}
  .redesign-root .cta-final h2{
    font-size:clamp(36px,6vw,72px); font-weight:800; letter-spacing:-0.02em; line-height:1.02; margin-bottom:32px; margin-top:0;
  }
  .redesign-root .cta-final h2 em{font-style:normal; color:var(--blue);}

  .redesign-root footer{padding:64px 0 32px; border-top:1px solid var(--line);}
  .redesign-root .foot-cols{display:grid; grid-template-columns:1.6fr 1fr 1fr 1fr; gap:40px; padding-bottom:48px; border-bottom:1px solid var(--line); margin-bottom:24px;}
  .redesign-root .foot-brand p{font-size:14px; color:#6b6e73; margin-top:14px; max-width:260px; line-height:1.55;}
  .redesign-root .foot-col-title{font-size:12px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin-bottom:16px;}
  .redesign-root .foot-col a{display:block; font-size:14px; color:#52555a; padding:6px 0; transition:color .2s;}
  .redesign-root .foot-col a:hover{color:var(--ink);}
  .redesign-root .foot-bottom{font-size:13px; color:#6b6e73;}

  @media (max-width:860px){
    .redesign-root .hero-grid{grid-template-columns:1fr;}
    .redesign-root .section-head{grid-template-columns:1fr;}
    .redesign-root .services-grid{grid-template-columns:1fr; border-left:none;}
    .redesign-root .service-cell{border-right:none;}
    .redesign-root .case-card{grid-template-columns:1fr; gap:14px; min-width:0;}
    .redesign-root .case-body{min-width:0;}
    .redesign-root .case-stack{
      flex-wrap:nowrap;
      overflow-x:auto;
      margin:0 -32px;
      padding:0 32px 4px;
      scrollbar-width:none;
    }
    .redesign-root .case-stack::-webkit-scrollbar{display:none;}
    .redesign-root .case-stack span{flex:0 0 auto;}
    .redesign-root .case-row{grid-template-columns:1fr;}
    .redesign-root .process-item{grid-template-columns:1fr; gap:8px;}
    .redesign-root .pricing-strip{grid-template-columns:1fr;}
    .redesign-root .pricing-cell{border-right:none; border-bottom:1px solid var(--line);}
    .redesign-root .network-grid{grid-template-columns:1fr;}
    .redesign-root .stats-track{grid-template-columns:1fr;}
    .redesign-root .stats-track span{border-right:none; border-bottom:1px solid var(--line); padding:12px 0;}
    .redesign-root .stats-track span:last-child{border-bottom:none;}
    .redesign-root .foot-cols{grid-template-columns:1fr; gap:32px;}

    .redesign-root .case-visual-row{
      flex-wrap:nowrap;
      overflow-x:auto;
      scroll-snap-type:x mandatory;
      -webkit-overflow-scrolling:touch;
      margin:24px -32px 0;
      padding:0 32px 10px;
      scrollbar-width:none;
    }
    .redesign-root .case-visual-row::-webkit-scrollbar{display:none;}
    .redesign-root .case-visual-row .browser-frame-sm,
    .redesign-root .case-visual-row .phone-frame-sm{
      flex:0 0 auto;
      scroll-snap-align:start;
    }
    .redesign-root .case-visual-row .browser-frame-sm{
      max-width:82vw;
      width:340px;
    }
    .redesign-root .case-visual-row .phone-frame-sm{
      width:200px;
    }

    .redesign-root nav{flex-wrap:wrap; row-gap:14px;}
    .redesign-root .nav-toggle{display:flex; flex-direction:column; justify-content:center; gap:5px; order:2; margin-left:auto;}
    .redesign-root .nav-actions{order:3;}
    .redesign-root .nav-links{
      display:none; order:4; width:100%; flex-direction:column; gap:0;
      border-top:1px solid var(--line); padding-top:8px;
    }
    .redesign-root .nav-links.open{display:flex;}
    .redesign-root .nav-links a{padding:14px 0; border-bottom:1px solid var(--line); opacity:1;}
  }
`;

const Redesign = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="redesign-root">
      <style>{css}</style>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;1,6..72,400&family=Inter:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />

      <header>
        <nav>
          <div className="logo">Data<span>Backfill</span></div>
          <button
            className="nav-toggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span></span><span></span><span></span>
          </button>
          <div className="nav-actions">
            <Link to="/auth" className="nav-login">Log in</Link>
            <Link to="/contact" className="nav-cta">Start a Project</Link>
          </div>
          <div className={`nav-links${menuOpen ? ' open' : ''}`}>
            <a href="#services" onClick={closeMenu}>Services</a>
            <a href="#work" onClick={closeMenu}>Case Studies</a>
            <a href="#process" onClick={closeMenu}>How we work</a>
            <a href="#team" onClick={closeMenu}>Team</a>
            <a href="#pricing" onClick={closeMenu}>Pricing</a>
          </div>
        </nav>
      </header>

      <section className="hero">
        <div className="wrap hero-grid">
          <div>
            <div className="eyebrow">Forward Deployed Engineering</div>
            <h1>Engineers who ship into your <em>production.</em></h1>
          </div>
          <div className="hero-side">
            <p>We send a senior engineer to you. They work in your stack, alongside your team, and stay until the system is live and running. Fixed fee, agreed before we start.</p>
            <div className="hero-actions">
              <Link to="/contact" className="btn-primary">Start a Project</Link>
              <a href="#work" className="btn-text">See Our Work →</a>
            </div>
            <div className="hero-status">
              <div className="row"><span className="dot done"></span><span className="label">Discover</span><span className="state">Complete</span></div>
              <div className="row"><span className="dot active"></span><span className="label">Build</span><span className="state">In progress</span></div>
              <div className="row"><span className="dot pending"></span><span className="label">Operate</span><span className="state">Queued</span></div>
            </div>
            <div className="hero-status-caption">How a typical engagement is tracked — <a href="#process" style={{ textDecoration: 'underline', color: '#3a3d42' }}>see how we work →</a></div>
          </div>
        </div>
      </section>

      <div className="stats-strip">
        <div className="wrap stats-track">
          <span><b>1,400+</b> successful syncs shipped</span>
          <span><b>99.9%</b> production uptime</span>
          <span><b>Hundreds</b> of properties served</span>
          <span><b>5.0</b> App Store rating on Tempo</span>
        </div>
      </div>

      <section className="section" id="services">
        <div className="wrap">
          <div className="section-head">
            <div className="section-num serif">01 — What we build</div>
            <div>
              <div className="section-title">Four practice areas. All of them end in production.</div>
              <p className="section-desc">No slide decks, no roadmap theater. Every engagement ships working software.</p>
            </div>
          </div>
        </div>
        <div className="wrap" style={{ padding: 0 }}>
          <div className="services-grid">
            <div className="service-cell">
              <div className="tag">Practice 01</div>
              <h3>Claude Implementation & Integration</h3>
              <p>We stand up Claude in production, integrated into your existing products, internal tools, or customer-facing applications.</p>
              <ul>
                <li>Production Claude deployments integrated with your stack</li>
                <li>Prompt engineering, evals, and guardrails</li>
                <li>Integration with existing products & internal tools</li>
              </ul>
            </div>
            <div className="service-cell">
              <div className="tag">Practice 02</div>
              <h3>RAG & Knowledge Systems</h3>
              <p>We build retrieval systems that let your AI work with proprietary data accurately, at scale, without hallucinating.</p>
              <ul>
                <li>Custom retrieval over proprietary data sources</li>
                <li>Vector databases, embedding pipelines, hybrid search</li>
                <li>Document ingestion, chunking, and indexing strategies</li>
              </ul>
            </div>
            <div className="service-cell">
              <div className="tag">Practice 03</div>
              <h3>Agentic Workflows & Automation</h3>
              <p>We design and ship multi-step agent systems that replace manual processes and unlock net-new capabilities.</p>
              <ul>
                <li>Multi-step agent systems for internal operations</li>
                <li>Tool use, function calling, and agent orchestration</li>
                <li>Workflow automation that replaces manual processes</li>
              </ul>
            </div>
            <div className="service-cell">
              <div className="tag">Practice 04</div>
              <h3>Data Infrastructure & Analytics</h3>
              <p>Modern data stacks that actually move data where it needs to go, architected and operated end to end.</p>
              <ul>
                <li>GA4, BigQuery, and data warehouse architecture</li>
                <li>ETL and reverse-ETL pipelines</li>
                <li>DataBackfill Sync as a productized reference implementation</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="work">
        <div className="wrap">
          <div className="section-head">
            <div className="section-num serif">02 — Case studies</div>
            <div>
              <div className="section-title">Production systems, not prototypes.</div>
              <p className="section-desc">We're selective about what we take on. Here's what we've shipped.</p>
            </div>
          </div>

          <div className="case-list">
            <div className="case-card">
              <div className="case-meta">
                <div className="kicker">SaaS</div>
                <div className="status">Live since 2024</div>
              </div>
              <div className="case-body">
                <h3>DataBackfill Sync</h3>
                <div className="sub">GA4 to BigQuery backfill SaaS</div>
                <div className="case-row">
                  <div><div className="label">Problem</div><p>Historical GA4 data isn't available in BigQuery by default — no reliable path for long-term trend analysis.</p></div>
                  <div><div className="label">Solution</div><p>A production SaaS that pulls historical GA4 data via the Data API directly into a customer's BigQuery instance. No data stored on our side.</p></div>
                  <div><div className="label">Outcome</div><p>1,400+ successful syncs. 99.9% uptime. Hundreds of properties served. Still running.</p></div>
                </div>
                <div className="case-stack">
                  <span>Python</span><span>Flask</span><span>React</span><span>BigQuery</span><span>GA4 Data API</span><span>Stripe</span><span>Descope</span>
                </div>
                <div className="case-visual case-visual-row">
                  <div className="browser-frame-sm">
                    <div className="bar"><i></i><i></i><i></i><span className="bar-label">Data Sync</span></div>
                    <img src="/redesign-assets/databackfill-dashboard.png" alt="DataBackfill Sync dashboard showing GA4 data sync configuration" />
                  </div>
                  <div className="browser-frame-sm">
                    <div className="bar"><i></i><i></i><i></i><span className="bar-label">Google Cloud Settings</span></div>
                    <img src="/redesign-assets/databackfill-gcloud.png" alt="DataBackfill Sync Google Cloud credentials and prerequisites checklist" />
                  </div>
                </div>
              </div>
            </div>

            <div className="case-card">
              <div className="case-meta">
                <div className="kicker">iOS App</div>
                <div className="status">Live on the App Store, 2026</div>
              </div>
              <div className="case-body">
                <h3>Tempo</h3>
                <div className="sub">Cycle-aware fitness app for women</div>
                <div className="case-row">
                  <div><div className="label">Problem</div><p>Generic training plans ignore how readiness and recovery shift across the menstrual cycle, producing worse outcomes and higher dropout.</p></div>
                  <div><div className="label">Solution</div><p>An adaptive fitness coach that learns from daily check-ins and adjusts workout intensity using cycle-phase context.</p></div>
                  <div><div className="label">Outcome</div><p>Live on the App Store as Tempo Cycle. 5.0 rating.</p></div>
                </div>
                <div className="case-stack">
                  <span>Swift</span><span>SwiftUI</span><span>HealthKit</span><span>RevenueCat</span><span>Supabase</span>
                </div>
                <div className="case-visual case-visual-row">
                  <div className="phone-frame-sm">
                    <img src="/redesign-assets/tempo-checkin.png" alt="Tempo app daily check-in screen with energy, sleep, soreness, and stress sliders" />
                  </div>
                  <div className="phone-frame-sm">
                    <img src="/redesign-assets/tempo-snapshot.png" alt="Tempo app results screen showing today's snapshot and cycle phase" />
                  </div>
                  <div className="phone-frame-sm">
                    <img src="/redesign-assets/tempo-suggestion.png" alt="Tempo app daily check-in screen showing a workout suggestion" />
                  </div>
                </div>
              </div>
            </div>

            <div className="case-card">
              <div className="case-meta">
                <div className="kicker">Platform</div>
                <div className="status">Live demo, 2026</div>
              </div>
              <div className="case-body">
                <h3>AssetOS</h3>
                <div className="sub">Operating system for special situations investing</div>
                <div className="case-row">
                  <div><div className="label">Problem</div><p>Special situations investors juggle tax liens, judgments, probate, minerals, and surplus funds across 5+ disconnected systems — Excel trackers, CRMs, manual deadline calendars. One missed redemption deadline can mean a five-figure loss.</p></div>
                  <div><div className="label">Solution</div><p>A unified platform with 7 specialized AI agents that calculate statutory interest across jurisdictions, monitor court dockets, generate legal forms, and track redemption deadlines around the clock.</p></div>
                  <div><div className="label">Outcome</div><p>170+ assets under management. Production-ready, MIT-licensed codebase. Live demo running across all 5 asset classes.</p></div>
                </div>
                <div className="case-stack">
                  <span>Google Cloud Run</span><span>Firestore</span><span>Python</span><span>Pydantic</span><span>React</span><span>RBAC</span>
                </div>
                <div className="case-visual">
                  <div className="browser-frame-sm">
                    <div className="bar"><i></i><i></i><i></i><span className="bar-label">Tax Liens Dashboard — live demo</span></div>
                    <img src="/redesign-assets/assetos-dashboard.png" alt="AssetOS Tax Liens Dashboard showing AI-powered distressed asset management tools" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="process">
        <div className="wrap">
          <div className="section-head">
            <div className="section-num serif">03 — How we work</div>
            <div>
              <div className="section-title">A repeatable delivery model built around shipping, not slide decks.</div>
              <p className="section-desc">Three stages. An engineer is embedded with your team for all of them.</p>
            </div>
          </div>
          <div className="process-list">
            <div className="process-item">
              <div className="process-step serif">01</div>
              <div>
                <h3>Discover</h3>
                <p>A scoped discovery sprint to understand the problem, the constraints, and the right shape of solution.</p>
              </div>
            </div>
            <div className="process-item">
              <div className="process-step serif">02</div>
              <div>
                <h3>Build</h3>
                <p>We ship working software, not recommendations. Every engagement ends with something in production.</p>
              </div>
            </div>
            <div className="process-item">
              <div className="process-step serif">03</div>
              <div>
                <h3>Operate</h3>
                <p>Hand off cleanly, or stay on retainer to evolve the system as your needs grow.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="team">
        <div className="wrap">
          <div className="section-head">
            <div className="section-num serif">04 — Who we are</div>
            <div>
              <div className="section-title">A senior bench. No junior tier.</div>
              <p className="section-desc">Every engagement gets a senior engineer embedded with your team. Not a manager relaying to a build happening somewhere else. The person in your standup is the person writing the code.</p>
            </div>
          </div>

          <div className="network-label">On the bench</div>
          <div className="network-grid">
            <div className="network-cell">
              <h4>AI & ML Engineering</h4>
              <p>Engineers who have shipped production AI systems: LLM integrations, fine-tuning, evals, and inference optimization.</p>
            </div>
            <div className="network-cell">
              <h4>Infrastructure Architecture</h4>
              <p>Architects who design for scale, reliability, and cost: cloud infrastructure, data platforms, and distributed systems.</p>
            </div>
            <div className="network-cell">
              <h4>Product Design for AI</h4>
              <p>Designers who understand AI constraints and build interfaces that make intelligent systems feel intuitive to end users.</p>
            </div>
            <div className="network-cell">
              <h4>Implementation & Delivery</h4>
              <p>Delivery leads who keep engagements on track: scoping, sequencing, and surfacing risk before it becomes a problem.</p>
            </div>
            <div className="network-cell">
              <h4>Full-Stack Engineering</h4>
              <p>Engineers who own the full surface: frontend, backend, APIs, and integrations, without handing off at every layer.</p>
            </div>
            <div className="network-cell">
              <h4>Data Engineering</h4>
              <p>Specialists in pipelines, warehouses, and data modeling who make sure the right data gets to the right place reliably.</p>
            </div>
          </div>

          <div className="assemble-block">
            <p>We staff by fit, not availability. Everyone on the bench has shipped production systems before, and nobody is learning on your project. We take a limited number of engagements at a time because the model only works if the engineer is actually present.</p>
          </div>
        </div>
      </section>

      <section className="quote-section">
        <div className="wrap">
          <p>"It never felt like hiring a vendor. It felt like adding a team that cared whether the thing actually worked."</p>
          <div className="by">— Co-Founder, Early-Stage Startup</div>
        </div>
      </section>

      <section className="section" id="pricing" style={{ paddingBottom: 0 }}>
        <div className="wrap">
          <div className="section-head">
            <div className="section-num serif">05 — Engagements</div>
            <div>
              <div className="section-title">Three shapes of work. All priced based on scope.</div>
              <p className="section-desc">No seat-based tiers. Scope drives price, and every engagement starts with a conversation.</p>
            </div>
          </div>
        </div>
        <div className="wrap" style={{ padding: 0 }}>
          <div className="pricing-strip">
            <div className="pricing-cell">
              <div className="tier">2 weeks · Fixed scope</div>
              <div className="price" style={{ fontSize: 28 }}>Discovery Sprint</div>
              <ul>
                <li>Technical plan & architecture diagram</li>
                <li>Rough estimate for the build</li>
                <li>Clear go / no-go recommendation</li>
              </ul>
            </div>
            <div className="pricing-cell">
              <div className="tier">6–12 weeks · Most common</div>
              <div className="price" style={{ fontSize: 28 }}>Build Engagement</div>
              <ul>
                <li>Architecture, engineering, integration</li>
                <li>Working software in production</li>
                <li>Documentation & handoff session</li>
              </ul>
            </div>
            <div className="pricing-cell">
              <div className="tier">Ongoing · Month-to-month</div>
              <div className="price" style={{ fontSize: 28 }}>Operate / Retainer</div>
              <ul>
                <li>Dedicated capacity post-launch</li>
                <li>Regular check-ins</li>
                <li>A team that already knows your stack</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-final">
        <div className="wrap">
          <h2>Ready to build<br />something <em>real?</em></h2>
          <Link to="/contact" className="btn-primary">Start a Project</Link>
        </div>
      </section>

      <footer>
        <div className="wrap foot-cols">
          <div className="foot-brand">
            <div className="logo">Data<span>Backfill</span></div>
            <p>A boutique studio of forward deployed engineers shipping agentic systems into production.</p>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Services</div>
            <a href="#services">Claude Implementation</a>
            <a href="#services">RAG & Knowledge Systems</a>
            <a href="#services">Agentic Workflows</a>
            <a href="#services">Data Infrastructure</a>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Company</div>
            <a href="#work">Case Studies</a>
            <a href="#team">Team</a>
            <a href="#pricing">Pricing</a>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Use Cases</div>
            <Link to="/use-cases/cmo">25 Use Cases for CMOs</Link>
            <Link to="/use-cases/marketing-ai">25 Marketing AI Use Cases</Link>
            <Link to="/use-cases/ai-bdr">25 AI BDR Use Cases</Link>
            <Link to="/use-cases/cfo">15 Use Cases for CFOs</Link>
            <Link to="/use-cases/customer-support">20 AI Customer Support Use Cases</Link>
            <Link to="/use-cases/revops">12 RevOps AI Use Cases</Link>
            <Link to="/use-cases/hr">10 AI Use Cases for HR Teams</Link>
            <Link to="/use-cases/data-teams">18 Use Cases for Data Teams</Link>
          </div>
        </div>
        <div className="wrap foot-bottom">
          <div>© 2026 DataBackfill. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
};

export default Redesign;
